import * as React from "react";
import { CorrectionItemPreviewProps, CorrectionItemPreview } from "../WizardTypings";
import { CorrectionBreakdownItem } from "../../CorrectionBreakdownItem";
import { Correction } from "../../../Request/DcfRequestReducer";

const PreviewSelector = (corrections: Correction[]): boolean => corrections.length > 0 && corrections[0].entity == "CoughSession" && corrections[0].field == "MediaSerialNumber";

const MediaSerialPreviewItem = ({ corrections }: CorrectionItemPreviewProps): JSX.Element => {
    if (!(PreviewSelector(corrections))) {
        return null;
    }

    return <CorrectionBreakdownItem fieldName={corrections[0].field} from={`FF${corrections[0].oldValue}`} to={`FF${corrections[0].newValue}`} />;
};

const MediaSerialPreview: CorrectionItemPreview = {
    previewElement: MediaSerialPreviewItem,
    previewSelector: PreviewSelector
};

export default MediaSerialPreview;
